<template>
 <div class="head">
  <div class="toutu">
    <img src="../../assets/yanwobianbie.jpg"></div>
  <div class="div_t">
    <div style="text-align: center;">
	<span style="font-size:26px;">&nbsp;燕窝辨别</span><br>
	<br>
	<span class="lh_hr" style="color:#ffcb8d;"><span style="overflow-wrap: break-word; margin: 0px; padding: 0px; font-family: 微软雅黑; font-size: 16px;"><span style="overflow-wrap: break-word;white-space: nowrap; margin: 0px; padding: 0px;">—————————————————————————————————————————————————————</span></span></span></div>
<div style="text-align: center;">
	<br>
	<span class="text">燕铺做燕窝七八年，一直本着诚信原则，给大家好的印度尼西亚官燕盏，积累了千万回头客。现在告诉大家辨别燕窝的方法，让大家懂得燕窝知识、变成行家、买到真正好燕窝。能够准确辨别燕窝真假，就不会上当受骗了！</span><br>
	<br>
	<div>
		<span style="font-size:26px;">【看】</span><br>
		<br>
		&nbsp;</div>
	<table align="center" border="0" cellpadding="0" cellspacing="0" style="margin-left: auto; margin-right: auto;">
		<tbody>
			<tr>
				<td>
					<img alt="" src="../../assets/1-1Z60414150S04.jpg" class="pic"></td>
				<td>
					&nbsp;</td>
				<td>
					<img alt="" src="../../assets/1-1Z524151503X1.png" class="pic"></td>
			</tr>
			<tr>
				<td>
					<span class="spantext">呈现的是米白色或米黄色，整体为丝状结构&nbsp;</span></td>
				<td>
					&nbsp;</td>
				<td>
					<span class="spantext">漂白、刷胶、添加,整体为片状结构，底部沾碎</span></td>
			</tr>
		</tbody>
	</table>
	<div>
		<br>
		<br>
		<span style="font-size:26px;">【闻】</span><br>
		<br>
		&nbsp;</div>
	<table align="center" border="0" cellpadding="0" cellspacing="0" style="margin-left: auto; margin-right: auto;">
		<tbody>
			<tr>
				<td>
					<img alt="" src="../../assets/1-1Z604140P4U3.jpg" class="pic"></td>
				<td>
					<img alt="" src="../../assets/1-1Z524151K49E.jpg" class="pic"></td>
			</tr>
			<tr>
				<td>
					<span class="spantext">原料是极轻毛燕，金丝燕燕窝，毛少干净，纯净水清洗后，有天然蛋清味</span></td>
				<td>
					<span class="spantext">&nbsp; &nbsp; &nbsp; &nbsp;原料是重毛燕，毛燕燕窝，因无法分离杂质和燕丝，品质和营养大打折扣</span></td>
			</tr>
		</tbody>
	</table>
	<div>
		&nbsp;</div>
	<div>
		<div>
			<span style="font-size:26px;">【泡】</span><br>
			<br>
			&nbsp;</div>
		<table align="center" border="0" cellpadding="0" cellspacing="0" style="margin-left: auto; margin-right: auto;">
			<tbody>
				<tr>
					<td>
						<img alt="" src="../../assets/1-1Z5241G002326.jpg" class="pic"></td>
					<td>
						<img alt="" src="../../assets/1-1Z5241G04YF.png" class="pic"></td>
				</tr>
				<tr>
					<td>
						<span class="spantext">泡发后，燕丝清晰、丝丝分明，泡发率8-10倍</span></td>
					<td>
						<span class="spantext">沾碎泡发后，燕丝断裂，发头小，不清透</span></td>
				</tr>
			</tbody>
		</table>
		<div>
			<br>
			<span style="font-size:26px;">【炖】</span><br>
			<br>
			&nbsp;</div>
		<table align="center" border="0" cellpadding="0" cellspacing="0" style="margin-left: auto; margin-right: auto;">
			<tbody>
				<tr>
					<td>
						<img alt="" src="../../assets/1-1Z5241K214300.jpg" class="pic"></td>
					<td>
						<img alt="" src="../../assets/1-1Z5241K351456.jpg" class="pic"></td>
				</tr>
				<tr>
					<td>
						<span class="spantext">燕丝长，有蛋清味，晶莹剔透，口感顺滑，营养价值高</span></td>
					<td>
						<span class="spantext">燕窝呈片状，炖不开，口感差，无味或者有化学品味</span></td>
				</tr>
			</tbody>
		</table>
		<div>
			&nbsp;</div>
	</div>
</div>
<br>

  </div>
</div>
</template>

<script>
	
export default {
  name: 'forumYpbb',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.toutu {
    width: 1120px;
    margin: auto;
}
.spantext{ font-size: 16px;}
.pic{ width: 350px;height: 280px;}
.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}
table{ width: 800px;}
.logo {
    margin-left: 449px;
    margin-top: 72px;
}


.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
.text{ font-size: 20px;}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 100%; margin-left: 0%;}
  .div_t{ width: 690px;}
  table{ width:690px;}
  .pic{ height:280px;}
  .text{ font-size: 24px;}
  .spantext{ font-size: 24px}
  .lh_hr{width: 690px;overflow: hidden;display: block;}
 
}     
</style>



// WEBPACK FOOTER //
// src/components/forum/ypbb.vue